<div
  class="print-card-background-container"
  [style.height.px]="viewModel.contentHeight$ | async"
  [style.width.px]="viewModel.contentWidth$ | async"
  [style.transform]="viewModel.transform$ | async"
  [style.transform-origin]="viewModel.transformOrigin$ | async">
  <app-print-card-background-inflator
    [preview]="preview"
    [cardBackground]="data"
    [style.overflow]="(viewModel.allowPrintCardBackgroundInflatorOverflow$ | async) ? 'visible' : 'hidden'" />

  <!-- blur overlay -->
  <div
    *ngIf="
      (this.data?.menu?.hydratedTheme?.themeFeatures?.blurredBackground | exists) &&
      (this.data?.menu?.menuOptions?.blurredBackground | exists)
    "
    class="print-card-background-blur"
    style="backdrop-filter: blur(10px)"></div>

  <!-- color overlay -->
  <!-- this is here in case for whatever reason, the menu signals are used instead of the section signals -->
  <!-- if card implements print card background or   -->
  <div
    class="print-card-background-color-overlay"
    [class]="this.data?.menu | printCardMenuBasicMethod: 'getBackgroundAssetWrapperClass'"
    [style.background-color]="
      (this.data?.menu?.hydratedTheme?.themeFeatures?.bodyBackgroundColor | exists)
        ? this.data?.menu?.menuOptions?.bodyBackgroundColor
        : ''
    "
    [style.opacity]="
      (data?.menu | printCardMenuBasicMethod: 'getOpacityEnabled')
        ? data?.menu?.menuOptions?.backgroundOpacity || '0'
        : '0'
    "
    [style.border-radius]="data?.menu | printCardMenuBasicMethod: 'getColorBackgroundAssetBorderRadius'"></div>
</div>
